/* app/ui/map/map.load */

define(
	'app/ui/map/map.load',[
		'jquery',
		'app/ui/map/map.control',
		'app/ui/map/map.interactive',
		'pubsub'
	],
	function($, MapControl, MapInteractive) {

		var MapLoad;

		// We use the 'Whitesite' account in the Terabyte Stats Google account Developer console
		// This needs to be updated to a client account attached to their billing account before go-live
		var apiKey = 'AIzaSyCGGYqm7Rro2q1OzQMJt9mFjbBbeM5llEE';
		var apiLoaded = false;
		var google;
		var $maps;

		return {
			init: function($elms) {
				MapLoad = this;
				$maps = $elms;

				var $firstMap = $maps.eq(0);

				// If only interactive map is on page initialise the module for this
				// The MapInteractive module will only load the API code if the map is toggled to display
				// Otherwise load API and init MapControl module
				if ($maps.length) {
					if ($maps.length === 1 && $firstMap.attr('data-map-type') === 'interactive') {
						MapInteractive.init($firstMap);
					} else {
						MapControl.init($maps);
					}
					MapLoad.loadApi();
				}
			},

			// Load Google Maps API version 3
			loadApi: function() {
				$.getScript('https://www.google.com/jsapi', function() {
					window.google.load('maps', '3', {
						other_params: '&key=' + apiKey,
						callback: MapLoad.mapApiLoaded
					});
				});
			},

			// Callback function once API is loaded
			mapApiLoaded: function() {
				apiLoaded = true;
				google = window.google;

				$.publish('/map/apiLoaded');
			},

			// Utility function to return API status and google object
			getMapApiStatus: function () {
				return {
					loaded: apiLoaded,
					google: google
				};
			}
		};
	}
);
